import React from "react";
import {Box, Chip, Colors, Text} from "@bounce/shared/ui";
import {FirstPartyChip} from "@bounce/shared/ui/components/FirstPartyChip";
import {SbtTemplate} from "../../apis/requests/sbt-templates/types";

type Props = {
  template: SbtTemplate;
};

export const SbtTemplateTypeChips = ({template}: Props) =>
  template.is_first_party ? (
    <Box sx={{display: "flex", alignItems: "center", gap: 1, minWidth: 0}}>
      <FirstPartyChip />
      <Text
        size={14}
        sx={{color: Colors.grey._700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}
      >
        {template.partner_names.join(", ")}
      </Text>
    </Box>
  ) : (
    <Chip label="3rd Party" variant_="secondary" size_="small" border />
  );
